import { SMARTYSTREETS_DPV_MATCH_CODES } from '../constants';

const { CONFIRMED_DROPPING_SECONDARY } = SMARTYSTREETS_DPV_MATCH_CODES;

const isDpvMatchCode = code => address =>
  getAddressDpvMatchCode(address) === code;

export const isDpvMatchCodeConfirmedDroppingSecondary = isDpvMatchCode(
  CONFIRMED_DROPPING_SECONDARY
);

export const getAddressDpvMatchCode = address =>
  (address.analysis || {}).dpv_match_code;

export const isErrorForced = error => forcedObj => !!(forcedObj || {})[error];

export const isPropertyValid = property => error => obj =>
  (obj || {})[property] !== error;

export const isStatusValid = isPropertyValid('status');
export const isClassificationValid = isPropertyValid('classification');
